import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { separarValorUnidad } from '../../helpers/splitValueUnit'
import GenericSelect from '../reutilizables/genericSelect/GenericSelect'

export const MetadatosCampos = ({
  metadato,
  actualizarMetadato,
  editable,
  esPublicar,
  guardarMetaDatoAdministrar
}) => {
  const valorActual = metadato.valorActual
  const [inputValue, setInputValue] = useState(null)
  const [unidadValue, setUnidadValue] = useState('')
  const tieneValor = Boolean(String(metadato.valorActual ?? '').trim())

  const tieneUnidad = metadato.idMetaDatoTipo === 'number_unit'
  const esCampoNumber =
    metadato.idMetaDatoTipo === 'number' || metadato.idMetaDatoTipo === 'number_unit'

  useEffect(() => {
    const { valorBase, unidad } = separarValorUnidad(valorActual, metadato.idMetaDatoTipo)
    setInputValue(valorBase)
    setUnidadValue(unidad)
  }, [valorActual])

  if (!editable && !tieneValor) {
    return null
  }

  return (
    <div key={metadato.idMetaDato} className="row align-items-center">
      {tieneValor && !editable && (
        <>
          <div className="d-none d-md-block col-md-3 text-right">
            {metadato.etiqueta}:
          </div>
          <div className="col-12 col-md-9">
            <div> {metadato.valor}</div>
          </div>
        </>
      )}
      {editable && (
        <>
          <div className="col-12 col-md-3 text-md-right">{metadato.etiqueta}:</div>
          <div className="col-12 col-md-9">
            {metadato.idMetaDatoTipo === 'boolean' ? (
              <div className="d-inline-block w-40 mb-1 mt-1">
                <GenericSelect
                  options={[
                    { value: 'Si', label: 'Si', key: 'si' },
                    { value: 'No', label: 'No', key: 'no' }
                  ]}
                  className="w-100 mr-0"
                  name="metadatos"
                  value={inputValue}
                  onChange={(valor) => {
                    setInputValue(valor)
                    actualizarMetadato(metadato.idMetaDato, valor)

                    if (!esPublicar) {
                      guardarMetaDatoAdministrar(metadato.idMetaDato, valor)
                    }
                  }}
                />
              </div>
            ) : (
              <>
                <input
                  type={esCampoNumber ? 'number' : 'text'}
                  name={'metadatos'}
                  className="input-text-bordered w-40 mb-1 mt-1"
                  value={
                    esCampoNumber
                      ? inputValue === '' || !isNaN(inputValue)
                        ? inputValue
                        : ''
                      : inputValue
                  }
                  onChange={(e) => {
                    setInputValue(e.target.value)
                    actualizarMetadato(
                      metadato.idMetaDato,
                      e.target.value,
                      tieneUnidad ? unidadValue : ''
                    )
                  }}
                  onBlur={() => {
                    if (!esPublicar) {
                      guardarMetaDatoAdministrar(
                        metadato.idMetaDato,
                        tieneUnidad ? `${inputValue} ${unidadValue}`.trim() : inputValue
                      )
                    }
                  }}
                ></input>
                {tieneUnidad && (
                  <input
                    type="text"
                    placeholder="Unidad"
                    name={`unidad_${metadato.idMetaDato}`}
                    className="input-text-bordered w-25 mb-1 mt-1 ml-1"
                    value={unidadValue}
                    onChange={(e) => {
                      actualizarMetadato(metadato.idMetaDato, inputValue, e.target.value)
                      setUnidadValue(e.target.value)
                    }}
                    onBlur={() => {
                      if (!esPublicar) {
                        guardarMetaDatoAdministrar(
                          metadato.idMetaDato,
                          `${inputValue} ${unidadValue}`.trim()
                        )
                      }
                    }}
                  />
                )}
              </>
            )}
          </div>
        </>
      )}
    </div>
  )
}

MetadatosCampos.propTypes = {
  metadato: PropTypes.shape({
    idMetaDato: PropTypes.number.isRequired,
    etiqueta: PropTypes.string.isRequired,
    valorActual: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    idMetaDatoTipo: PropTypes.string.isRequired,
    valor: PropTypes.string
  }).isRequired,
  actualizarMetadato: PropTypes.func.isRequired,
  editable: PropTypes.bool.isRequired,
  esPublicar: PropTypes.bool.isRequired,
  guardarMetaDatoAdministrar: PropTypes.func.isRequired
}
